export default "__VITE_ASSET__Dkd7usmv__"